import { css } from 'glamor';
import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import RadioGroupInput, { RadioGroupInputProps } from '../input/basicInputs/RadioGroupInput';
import { Omit, Overwrite } from '../../../typings/typings';
import { Classes, IOptionProps } from '@blueprintjs/core';
import classNames from 'classnames';

type options = Overwrite<IOptionProps, { value: string }>;

const formFieldClassName = classNames(Classes.FORM_GROUP, css({ margin: 0 }).toString());

class RadioGroupFormField extends React.Component<
  BaseFormFieldProps &
    Omit<RadioGroupInputProps, 'onChange'> & {
      options?: options[];
      onChange?: (value: any) => void;
    }
> {
  render() {
    return (
      <FormField {...this.props} className={formFieldClassName}>
        {({ input }) => (
          <RadioGroupInput
            {...input}
            selectedValue={input.value}
            onChange={(e) => {
              input.onChange(e.currentTarget.value);
            }}
          >
            {React.Children.map(this.props.children, (child: any) =>
              React.cloneElement(child, {
                checked: child.props.value === input.value,
                onChange: (e: any) => {
                  input.onChange(e.currentTarget.value);
                  if (this.props.onChange) {
                    this.props.onChange(e.currentTarget.value);
                  }
                },
              }),
            )}
          </RadioGroupInput>
        )}
      </FormField>
    );
  }
}

export default RadioGroupFormField;
